<template>
  <li class="f-accordion-item">
    <div
      class="f-accordion-item-title"
      :class="{'is-active': visible}"
      @click="toggleOpen">
      <slot name="accordion-item-title"></slot>
    </div>

    <transition name="accordion">
      <div
        class="f-accordion-item-content"
        v-show="visible">
        <slot name="accordion-item-content"></slot>
      </div>
    </transition>
  </li>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'f-accordion-item',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    toggleEvent: {
      type: Function
    }
  },
  data() {
    return {
      visible: false
    };
  },
  mounted () {
    Vue.set(this, 'visible', this.active);
  },
  methods: {
    toggleOpen() {
      Vue.set(this, 'visible', !this.visible);
      if (this.toggleEvent) {
        Vue.nextTick(() => {
          this.toggleEvent(this.visible)
        });
      }
    },
    open() {
      Vue.set(this, 'visible', true);
      if (this.toggleEvent) {
        Vue.nextTick(() => {
          this.toggleEvent(true)
        });
      }
    }
  }
};
</script>
